(function () {
  'use strict';

  const STORAGE_KEY = 'regikit-b2b-vat-mode';

  class RegikitB2BVat {
    constructor() {
      this.toggles = document.querySelectorAll('.regikit-vat-toggle');
      if (!this.toggles.length) return;

      this._isRecalculating = false;

      const first = this.toggles[0];
      this.vatRate = parseFloat(first.dataset.vatRate) / 100;
      this.pricesIncludeVat = first.dataset.vatIncluded === 'true';
      this.defaultMode = first.dataset.vatDefault || 'incl';
      this.inclLabel = first.dataset.vatInclLabel;
      this.exclLabel = first.dataset.vatExclLabel;

      this.mode = localStorage.getItem(STORAGE_KEY) || this.defaultMode;

      this.init();
    }

    init() {
      this.syncToggles();
      this.recalculateAllPrices();
      this.updateAllLabels();

      // Click handler con capture: true per precedere il MenuDrawer
      this.toggles.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.stopImmediatePropagation();
          this.mode = this.mode === 'incl' ? 'excl' : 'incl';
          localStorage.setItem(STORAGE_KEY, this.mode);
          this.syncToggles();
          this.recalculateAllPrices();
          this.updateAllLabels();
        }, true);
      });

      // Re-apply after cart updates
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
          setTimeout(() => {
            this.recalculateAllPrices();
            this.updateAllLabels();
          }, 300);
        });
      }

      // MutationObserver con debounce per contenuti dinamici
      const debouncedRecalc = typeof debounce === 'function'
        ? debounce(() => { this.recalculateAllPrices(); this.updateAllLabels(); }, 100)
        : (() => {
            let timer;
            return () => { clearTimeout(timer); timer = setTimeout(() => { this.recalculateAllPrices(); this.updateAllLabels(); }, 100); };
          })();

      this.observer = new MutationObserver((mutations) => {
        if (this._isRecalculating) return;
        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === 1 && (node.matches?.('[data-price-cents]') || node.querySelector?.('[data-price-cents]'))) {
              debouncedRecalc();
              return;
            }
          }
        }
      });

      this.observer.observe(document.body, { childList: true, subtree: true });
    }

    syncToggles() {
      const isExcl = this.mode === 'excl';
      this.toggles.forEach((btn) => {
        btn.setAttribute('aria-pressed', String(isExcl));
        const label = btn.querySelector('.regikit-vat-toggle__label');
        if (label) label.textContent = isExcl ? this.exclLabel : this.inclLabel;
      });
    }

    calculatePrice(cents) {
      if (this.pricesIncludeVat && this.mode === 'excl') {
        return Math.round(cents / (1 + this.vatRate));
      }
      if (!this.pricesIncludeVat && this.mode === 'incl') {
        return Math.round(cents * (1 + this.vatRate));
      }
      return cents;
    }

    formatMoney(cents) {
      const amount = (cents / 100).toFixed(2);
      const currency = typeof Regikit !== 'undefined' ? Regikit.currency : {};
      const symbol = currency.symbol || '';
      const code = currency.code || '';

      const parts = amount.split('.');
      const intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const formatted = intPart + '.' + parts[1];

      const useCode = typeof Regikit !== 'undefined' && Regikit.settings && Regikit.settings.currency_code_enabled;
      if (useCode && code) return symbol + formatted + ' ' + code;
      return symbol + formatted;
    }

    recalculateAllPrices() {
      this._isRecalculating = true;

      const elements = document.querySelectorAll('[data-price-cents]');
      const updates = [];

      // Read phase: collect data and find target text nodes
      elements.forEach((el) => {
        const originalCents = parseInt(el.dataset.priceCents, 10);
        if (isNaN(originalCents)) return;

        const newCents = this.calculatePrice(originalCents);
        const formatted = this.formatMoney(newCents);

        const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
        let targetNode = null;
        let node;
        while ((node = walker.nextNode())) {
          if (node.textContent.trim() && /\d/.test(node.textContent)) {
            targetNode = node;
            break;
          }
        }
        updates.push({ el, targetNode, formatted });
      });

      // Write phase: apply all DOM updates in batch
      for (const { el, targetNode, formatted } of updates) {
        if (targetNode) {
          targetNode.textContent = formatted;
        } else {
          el.textContent = formatted;
        }
      }

      this._isRecalculating = false;
    }

    updateAllLabels() {
      const labelText = this.mode === 'incl' ? this.inclLabel : this.exclLabel;
      document.querySelectorAll('.regikit-vat-label').forEach((el) => {
        el.textContent = labelText;
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new RegikitB2BVat());
  } else {
    new RegikitB2BVat();
  }
})();
